// extracted by mini-css-extract-plugin
module.exports = {"card":"_1WrZe-Ts _2IVOPH9e","border":"_1phC251X mp0IAnUX _3paVjF5W","padding":"_3TxgTi4X"};